import React from "react";
import {useLocation} from "react-router-dom";
import paths from "../../paths";
import {useMutualSlipOptions} from "../../features/betslip/mutual.service";
import {FOBBetslip, useFobBetslip} from "../../features/betslip/fob.service";
import {LongtermBetslip, useLongtermBetslip} from "../../features/betslip/longterm.service";
import {FobBetslipPage} from "../betting/fob.betting/fob.betslip";
import {MutualBetslipPage} from "../betting/mutual.betting/mutual.betslip";
import {LongtermBetslipPage} from "../betting/longterm.betting/longterm.betslip";

/**
 * `/bilet-onay` rotası. Tek işi hangi türün kupon sayfasının çizileceğine karar vermek;
 * kupon panelinin KENDİSİ türe ait dosyada. Üç tür arasında paylaşılan betslip kodu YOK -
 * bir türde yapılan değişiklik diğerlerini kırmasın diye bilerek böyle.
 */
export function BetslipPage() {
    const {pathname, state} = useLocation();
    useLongtermBetslip();
    useFobBetslip();
    useMutualSlipOptions();

    const sourceType = (state as any)?.type;
    if (sourceType === "longterm") {
        return <LongtermBetslipPage/>;
    }
    if (sourceType === "fob") {
        return <FobBetslipPage/>;
    }
    if (sourceType === "mutual") {
        return <MutualBetslipPage/>;
    }

    if (pathname.includes(paths.bettingLongterm.url) || LongtermBetslip.getSelection() !== null) {
        return <LongtermBetslipPage/>;
    }
    if (pathname.includes(paths.bettingFob.url) || FOBBetslip.getAll().length > 0) {
        return <FobBetslipPage/>;
    }
    return <MutualBetslipPage/>;
}
